import type { HelpSource } from '../../../help/types'
import type { QoeHelpEntry, QoeHelpId } from './qoeHelpContent'
import { QOE_HELP_TITLES } from './qoeHelpTitles'

// The full content is ~350 KB of text, so it is fetched the first time any popover opens (or its button is
// hovered or focused) instead of shipping with every CFO page load. Titles ship with the page.
let contentPromise: Promise<Record<QoeHelpId, QoeHelpEntry>> | null = null
let loadedContent: Record<QoeHelpId, QoeHelpEntry> | null = null
export const loadedQoeHelpContent = () => loadedContent
export function loadQoeHelpContent() {
  contentPromise ??= import('./qoeHelpContent').then(module => (loadedContent = module.QOE_HELP_CONTENT)).catch(error => { contentPromise = null; throw error })
  return contentPromise
}

/** The QoE namespace as an FgHelp source: titles with the page, bodies on demand. */
export const QOE_HELP_SOURCE: HelpSource = {
  title: id => QOE_HELP_TITLES[id as QoeHelpId],
  loaded: loadedQoeHelpContent,
  load: loadQoeHelpContent,
}
